// @ts-nocheck
(() => {
  const SECTION_SELECTOR = '.slider-video-ugc[data-section-id]';
  const SWIPER_RETRY_DELAY = 120;
  const SWIPER_MAX_RETRIES = 20;

  const bindQuickAddButtons = (section) => {
    const quickAddButtons = section.querySelectorAll('.slider-video-ugc__quick-add[data-variant-id]');

    quickAddButtons.forEach((button) => {
      if (button.dataset.quickAddBound === 'true') return;
      button.dataset.quickAddBound = 'true';

      button.addEventListener('click', async () => {
        if (button.disabled) return;

        const variantId = Number(button.dataset.variantId || '0');
        const quantity = Number(button.dataset.quantity || '1') || 1;
        if (!variantId) return;

        button.disabled = true;

        try {
          const payload = {
            items: [{
              id: variantId,
              quantity
            }]
          };

          const cartComponents = document.querySelectorAll('cart-items-component[data-section-id]');
          const sectionIds = Array.from(cartComponents)
            .map((component) => component.dataset.sectionId)
            .filter(Boolean);

          if (sectionIds.length > 0) {
            payload.sections = sectionIds.join(',');
            payload.sections_url = window.location.pathname + window.location.search;
          }

          const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(payload)
          });

          const result = await response.json();
          if (result.status) {
            throw new Error(result.description || result.message || 'Add to cart failed');
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: result,
                sourceId: section.dataset.sectionId || 'slider-video-ugc',
                data: {
                  source: 'product-form-component',
                  itemCount: quantity,
                  sections: result.sections || {}
                }
              }
            })
          );

          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
          }
        } catch (error) {
          console.error(error);
        } finally {
          button.disabled = false;
        }
      });
    });
  };

  const initVideoBehavior = (section) => {
    const videos = section.querySelectorAll('.slider-video-ugc__video');
    if (!videos.length) return;

    const startMuted = section.dataset.startMuted === 'true';
    const autoplayOnViewport = section.dataset.autoplayOnViewport === 'true';
    const clickToUnmute = section.dataset.clickToUnmute === 'true';
    const playVideoLabel = section.dataset.playVideoLabel || 'Play video';
    const pauseVideoLabel = section.dataset.pauseVideoLabel || 'Pause video';

    const updateCardControls = (video) => {
      const card = video.closest('.slider-video-ugc__video-card');
      if (!card) return;

      const playButton = card.querySelector('[data-video-control="play"]');
      const playIcon = card.querySelector('.slider-video-ugc__control-icon--play');
      const pauseIcon = card.querySelector('.slider-video-ugc__control-icon--pause');
      const muteButton = card.querySelector('[data-video-control="mute"]');
      const mutedIcon = card.querySelector('.slider-video-ugc__control-icon--muted');
      const unmutedIcon = card.querySelector('.slider-video-ugc__control-icon--unmuted');

      if (playButton && playIcon && pauseIcon) {
        const isPaused = video.paused;
        playIcon.classList.toggle('hidden', !isPaused);
        pauseIcon.classList.toggle('hidden', isPaused);
        playButton.setAttribute('aria-pressed', String(!isPaused));
        playButton.setAttribute('aria-label', isPaused ? playVideoLabel : pauseVideoLabel);
      }

      if (muteButton && mutedIcon && unmutedIcon) {
        const isMuted = video.muted;
        mutedIcon.classList.toggle('hidden', !isMuted);
        unmutedIcon.classList.toggle('hidden', isMuted);
        muteButton.setAttribute('aria-pressed', String(isMuted));
      }
    };

    videos.forEach((video) => {
      video.muted = startMuted;
      video.loop = true;
      video.playsInline = true;

      const card = video.closest('.slider-video-ugc__video-card');
      const playButton = card ? card.querySelector('[data-video-control="play"]') : null;
      const muteButton = card ? card.querySelector('[data-video-control="mute"]') : null;

      if (playButton && playButton.dataset.bound !== 'true') {
        playButton.dataset.bound = 'true';
        playButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
          updateCardControls(video);
        });
      }

      if (muteButton && muteButton.dataset.bound !== 'true') {
        muteButton.dataset.bound = 'true';
        muteButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          video.muted = !video.muted;
          if (video.paused) {
            video.play().catch(() => {});
          }
          updateCardControls(video);
        });
      }

      if (clickToUnmute && video.dataset.unmuteBound !== 'true') {
        video.dataset.unmuteBound = 'true';
        video.addEventListener('click', () => {
          video.muted = !video.muted;
          if (video.paused) {
            video.play().catch(() => {});
          }
          updateCardControls(video);
        });
      }

      if (video.dataset.stateBound !== 'true') {
        video.dataset.stateBound = 'true';
        video.addEventListener('play', () => updateCardControls(video));
        video.addEventListener('pause', () => updateCardControls(video));
        video.addEventListener('volumechange', () => updateCardControls(video));
      }

      updateCardControls(video);
    });

    if (!autoplayOnViewport || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!(video instanceof HTMLVideoElement)) return;

        if (entry.isIntersecting) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.35 });

    videos.forEach((video) => observer.observe(video));
  };

  const initSwiper = (section) => {
    const carousel = section.querySelector('[data-slider-video-ugc-swiper]');
    if (!carousel) return;
    const track = carousel.querySelector('.slider-video-ugc__track');

    const markCarouselReady = () => {
      carousel.classList.add('slider-video-ugc__carousel--ready');
      if (track && track.hasAttribute('hidden')) {
        track.removeAttribute('hidden');
      }
    };

    const slides = Array.from(carousel.querySelectorAll('.slider-video-ugc__slide.swiper-slide'));
    let swiperInstance = null;
    let retryCount = 0;

    const enableAutoplay = section.dataset.enableAutoplay === 'true';
    const autoplaySeconds = Number(section.dataset.autoplaySpeed || '4');
    const autoplayDelay = Math.max(2, Math.min(10, autoplaySeconds)) * 1000;
    const enableLoop = slides.length > 1;
    const enableRewind = false;
    const featuredIndex = 0;

    if (!slides.length) {
      markCarouselReady();
      return;
    }

    const buildSwiper = () => {
      if (swiperInstance) return;

      if (!window.Swiper) {
        if (retryCount < SWIPER_MAX_RETRIES) {
          retryCount += 1;
          window.setTimeout(buildSwiper, SWIPER_RETRY_DELAY);
        } else {
          markCarouselReady();
        }
        return;
      }

      const config = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: true,
        centeredSlidesBounds: false,
        loop: enableLoop,
        rewind: enableRewind,
        speed: 800,
        cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        watchOverflow: false,
        initialSlide: featuredIndex,
        resistanceRatio: 0.85, // un poco más suave
        breakpoints: {
          769: {
            spaceBetween: 16
          },
          1200: {
            spaceBetween: 16
          }
        }
      };

      if (enableAutoplay) {
        config.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      swiperInstance = new window.Swiper(carousel, config);

      if (enableLoop && typeof swiperInstance.slideToLoop === 'function') {
        swiperInstance.slideToLoop(featuredIndex, 0, false);
      } else {
        swiperInstance.slideTo(featuredIndex, 0, false);
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          markCarouselReady();
        });
      });
    };

    buildSwiper();
  };

  const initSection = (section) => {
    if (section.dataset.sliderVideoUgcInitialized === 'true') return;
    section.dataset.sliderVideoUgcInitialized = 'true';

    bindQuickAddButtons(section);
    initVideoBehavior(section);
    initSwiper(section);
  };

  const init = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => initSection(section));
  };

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
